import { createSlice } from "@reduxjs/toolkit";
import moment from "moment-timezone";
import { parseOrderByCharacter } from "../utils/helper";

export const orderSlice = createSlice({
  name: "order",
  initialState: null,
  reducers: {
    setOrder: (state, action) => {
      const order = action.payload;
      // const data = order?.map((item) =>
      //   parseOrderByCharacter(blacklist, mappingCourier, item)
      // );
      // try {
      //   order.shipping_address = JSON.parse(order.shipping_address);
      // } catch (error) {
      //   order.shipping_address = {};
      // }

      // try {
      //   order.tracking_detail = JSON.parse(order.tracking_detail);
      // } catch {
      //   order.tracking_detail = [];
      // }

      // try {
      //   order.customer = JSON.parse(order.customer);
      // } catch {
      //   order.customer = {};
      // }

      // if (!order?.tracking_number) {
      //   order.tracking_summary = "pending";
      // }

      return order;
    },
    parseOrder: (state, action) => {
      const { newTrackingDetail, newTrackingCompany } = action.payload;
      state.tracking_detail = newTrackingDetail;
      state.tracking_company = newTrackingCompany;
    },

    resetOrder: (state) => {
      return null;
    },
    parseDateTime: (state, action) => {
      // console.log(123, moment().format("LLLL"));
      return {
        ...state,
        tracking_detail: state.tracking_detail.map((item) => ({
          message: item.message,
          date_time: moment
            .tz(item.date_time, "America/Toronto")
            .utc()
            .format("YYYY/MM/DD HH:mm:ss"),
        })),
      };
    },
    updateOrder: (state, action) => {
      const { orderIndex } = action.payload;

      if (!state) {
        return { ...state };
      }

      // const index = state.findIndex((obj) => obj.order_id == order_id);

      // if (index < 0) {
      //   return { ...state };
      // }
      state[orderIndex] = { ...state[orderIndex], ...action.payload };
    },
  },
});

export const { setOrder, resetOrder, parseOrder, parseDateTime, updateOrder } =
  orderSlice.actions;
export default orderSlice.reducer;
